import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Vector2Pt extends OBase {
  update () {
    let aValTree = this.getVector3Input('Point A', false);
    let bValTree = this.getVector3Input('Point B', false);
    let uValTree = this.getBoolInput('Unitize');

    let vOutput = this.getGenericObjectOutput('Vector');
    let lOutput = this.getGenericObjectOutput('Length');

    let dataTrees = [aValTree, bValTree, uValTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let vOutTree = new Geometry.DataTree();
    let lOutTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let aVal = outDataTrees[0].branches[i][j];
        let bVal = outDataTrees[1].branches[i][j];
        let uVal = outDataTrees[2].branches[i][j];

        let sub = (new THREE.Vector3()).subVectors(bVal, aVal);
        let len = sub.length();

        if (uVal) {
          sub.normalize();
        }

        vOutTree.add(sub, outDataTrees[0].paths[i]);
        lOutTree.add(len, outDataTrees[0].paths[i]);
      }
    }

    vOutput.value = vOutTree;
    lOutput.value = lOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Vector2Pt.js